import { ContractorType, type ContractorTypeValue } from "../api/CrmApi";
import StatusPill from "../../../shared/StatusPill";
import type { Tone } from "../../../shared/tones";

const STYLES: Record<ContractorTypeValue, { label: string; tone: Tone }> = {
  [ContractorType.Prime]: { label: "prime", tone: "success" },
  [ContractorType.Sub]: { label: "sub", tone: "info" },
  [ContractorType.Unconfirmed]: { label: "role unconfirmed", tone: "warning" },
};

// A person with no classification (no active appearance and no human override) shows no badge.
export default function ContractorTypeBadge({ type, className = "" }: { type: ContractorTypeValue | null; className?: string }) {
  const style = type === null ? undefined : STYLES[type];
  if (!style) return null;
  return (
    <StatusPill
      tone={style.tone} size="sm" className={className}
      title={type === ContractorType.Unconfirmed ? "The sheet did not say whether this company is a prime or a sub on this RFP. A person decides before any email is drafted." : undefined}
    >{style.label}</StatusPill>
  );
}
